import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'vocativeName',
    pure: false,
    standalone: false
})
export class VocativeNamePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(user: any): string {
    if (!user) {
      return '';
    }
    const currentLang = this.translateService.getCurrentLang() || 'en';
    if (currentLang == 'cz' && user.first_name_fifth_fall) {
      return user.first_name_fifth_fall;
    }

    return user.first_name || '';
  }
}
